export default __webpack_public_path__ + "00948f96fed9eb860703be7003442363.png";